/* eslint-disable @typescript-eslint/no-explicit-any */

import {
  Avatar,
  Button,
  Card,
  Collapse,
  Dropdown,
  Image,
  Progress,
  Tag,
  Tooltip,
} from "antd";
import { SelectArrow } from "../../../../atoms/CustomIcons";

import UnscheduleIcon from "../../../../atoms/CustomIcons/UnscheduleIcon";
import RescheduleIcon from "../../../../atoms/CustomIcons/RescheduleIcon";
// import MarkAsNotCompleted from "../../../../atoms/CustomIcons/MarkAsNotCompleted";
import CancelIcon from "../../../../atoms/CustomIcons/CancelIcon";
import { MoreOutlined } from "@ant-design/icons";
import {
  formatEstimatedHrs,
  WORK_ORDER_STATUS,
} from "../../../../config/utils";
import { Fragment, useEffect, useRef, useState } from "react";
import {
  confirmWorkOrders,
  scheduleAsSeparateVisit,
  unscheduleVisit,
  unscheduleWorkOrderFromVisit,
} from "../../ducks/services";
import RescheduleVisits from "../RescheduleVisits";
import { PopUp } from "../../../../atoms/PopUp";
import { SuccessMessage } from "../../../../atoms/Toasts/SuccessMessage";
import { useNavigate } from "react-router-dom";
import { AxiosError } from "axios";
import { ErrorMessage } from "../../../../atoms/Toasts/ErrorMessage";
import { useAppDispatch } from "../../../../config/hooks";
import { getScheduleByDay } from "../../ducks/actions";
import dayjs from "dayjs";
import ConfirmDelete from "../../../../atoms/ConfirmDelete";

function PopOverCard(props: any) {
  const {
    visitData,
    crewId,
    companyId,
    setLoading,
    selectedDate,
    loading,
    oldDate,
  } = props;
  const navigate = useNavigate();
  const dropdownRef = useRef<HTMLButtonElement>(null);
  const dispatch = useAppDispatch();
  const [visitWorkOrderData, setVisitWorkOrderData] = useState<any>(null);
  const [rescheduleVisitModal, setRescheduleVisitModal] = useState(false);
  const [rescheduleWOModal, setRescheduleWOModal] = useState(false);
  const [workOrderId, setWorkOrderId] = useState<string | null>(null);
  const [confirmAllWO, setConfirmAllWO] = useState(false);
  const [confirmUnschedule, setConfirmUnschedule] = useState(false);
  const [confirmUnscheduleWO, setConfirmUnscheduleWO] = useState(false);
  const [separateVisitModal, setSeparateVisitModal] = useState(false);
  const [workOrderIds, setWorkOrderIds] = useState<string[]>([]);
  const [taskIds, setTaskIds] = useState<string[]>([]);

  const separateVisitFnc = () => {
    setLoading(true);
    const payload = {
      visit_work_order_id: workOrderId,
      schedule_id: visitWorkOrderData?.schedule_id,
    };
    scheduleAsSeparateVisit(payload)
      .then(() => {
        const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");
        dispatch(getScheduleByDay(formattedDate));
        SuccessMessage("Scheduled moved");
        setSeparateVisitModal(false);
        setLoading(false);
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
          setLoading(false);
        } else {
          ErrorMessage("Something went wrong");
          setLoading(false);
        }
      });
  };

  const unscheduleWorkOrderFnc = () => {
    setLoading(true);
    const payload = {
      visit_id: visitData?.id,
      work_order_id: workOrderId,
    };
    unscheduleWorkOrderFromVisit(payload)
      .then(() => {
        const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");
        dispatch(getScheduleByDay(formattedDate));
        setLoading(false);
        setConfirmUnscheduleWO(false);
        SuccessMessage("Visit unscheduled");
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
          setLoading(false);
        } else {
          ErrorMessage("Something went wrong");
          setLoading(false);
        }
      });
  };
  const unscheduleVisitFnc = () => {
    setLoading(true);
    unscheduleVisit([visitData?.id])
      .then(() => {
        const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");
        dispatch(getScheduleByDay(formattedDate));
        SuccessMessage("Visit unscheduled");
        setConfirmUnscheduleWO(false);
        setLoading(false);
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
          setLoading(false);
        } else {
          ErrorMessage("Something went wrong");
          setLoading(false);
        }
      });
  };

  const unscheduleRemainingVisitsPopUp = {
    visibility: confirmUnschedule,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setConfirmUnschedule(false)}
        heading="Confirm unschedule"
        paragraph="Are you sure you want to unschedule"
        btnText="Confirm"
        btnApi={unscheduleVisitFnc}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setConfirmUnschedule(false),
  };

  const unscheduleRemainingWOPopUp = {
    visibility: confirmUnscheduleWO,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setConfirmUnscheduleWO(false)}
        heading="Confirm unschedule"
        paragraph="Are you sure you want to unschedule"
        btnText="Confirm"
        btnApi={unscheduleWorkOrderFnc}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setConfirmUnscheduleWO(false),
  };

  const separateVisitPopUp = {
    visibility: separateVisitModal,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setSeparateVisitModal(false)}
        heading="Confirm schedule as a separate visit (same day)"
        paragraph="Are you sure you want to schedule as a separate visit on the same day?"
        btnText="Confirm"
        isArchivePopup
        btnApi={separateVisitFnc}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setSeparateVisitModal(false),
  };

  const itemsScheduled = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            setRescheduleVisitModal(true);
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          <RescheduleIcon /> Reschedule
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            setConfirmUnschedule(true);
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          <UnscheduleIcon /> Unschedule
        </Button>
      ),
    },
  ];

  const itemsPending = [
    // {
    //   key: "1",
    //   label: (
    //     <Button
    //       type="text"
    //       className="no-hover"
    //       onClick={(e) => {
    //         e.stopPropagation();
    //       }}
    //     >
    //       <MarkAsNotCompleted /> Mark as not completed
    //     </Button>
    //   ),
    // },
    {
      key: "2",
      disabled: true,
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
          disabled
        >
          <RescheduleIcon /> Reschedule partially
        </Button>
      ),
    },
  ];

  // const itemsCompleted = [
  //   {
  //     key: "1",
  //     label: (
  //       <Button
  //         type="text"
  //         className="no-hover"
  //         onClick={(e) => {
  //           e.stopPropagation();
  //         }}
  //       >
  //         <MarkAsNotCompleted /> Mark as not completed
  //       </Button>
  //     ),
  //   },
  //   // {
  //   //   key: "2",
  //   //   label: (
  //   //     <Button
  //   //       type="text"
  //   //       className="no-hover"
  //   //       onClick={(e) => {
  //   //         e.stopPropagation();
  //   //       }}
  //   //     >
  //   //       <RescheduleIcon /> Reschedule partially
  //   //     </Button>
  //   //   ),
  //   // },
  // ];

  const itemsInProgress = [
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <CancelIcon /> Cancel completion
        </Button>
      ),
    },
  ];

  const itemsWorkOrder = [
    {
      key: "1",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/work-orders-profile/${workOrderId}/${companyId}`);
          }}
        >
          <img src="/images/schedule/popup/document.svg" alt="document" /> View
          details
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            setRescheduleWOModal(true);
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          <RescheduleIcon /> Reschedule
        </Button>
      ),
    },
    {
      key: "3",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            setConfirmUnscheduleWO(true);
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          <UnscheduleIcon /> Unschedule
        </Button>
      ),
    },
    {
      key: "4",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();

            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
            setSeparateVisitModal(true);
          }}
        >
          <img src="/images/schedule/popup/separate.svg" alt="separate" />{" "}
          Schedule as a separate visit (same day)
        </Button>
      ),
    },
  ];

  let cardClass = "default_tag";
  if (visitData?.status === "COMPLETED") {
    cardClass += " grey_tag";
  } else if (visitData?.status === "CONFIRMATION_PENDING") {
    cardClass += " blue_tag";
  } else if (visitData?.status === "IN_PROGRESS") {
    cardClass += " purple_tag";
  } else if (visitData?.status === "SCHEDULED") {
    cardClass += " mint_tag ";
  }

  const btnRescheduleVisits = async () => {
    SuccessMessage("Visits rescheduled");
    setRescheduleVisitModal(false);
  };

  const rescheduleVisit = {
    visibility: rescheduleVisitModal,
    content: (
      <RescheduleVisits
        onClose={() => setRescheduleVisitModal(false)}
        btnApi={btnRescheduleVisits}
        loading={loading}
        visitId={visitData?.id}
        crewId={crewId}
      />
    ),
    width: 360,
    onCancel: () => setRescheduleVisitModal(false),
  };

  const rescheduleWO = {
    visibility: rescheduleWOModal,
    content: (
      <RescheduleVisits
        onClose={() => setRescheduleWOModal(false)}
        btnApi={btnRescheduleVisits}
        loading={loading}
        workOrderId={workOrderId}
        visitId={visitData?.id}
        crewId={crewId}
        oldDate={oldDate}
        setLoading={setLoading}
      />
    ),
    width: 360,
    onCancel: () => setRescheduleWOModal(false),
  };

  const btnConfirmAllWorkOrders = async () => {
    setLoading(true);
    const payload = {
      work_order_id: workOrderId,
      visit_id: visitData?.id,
    };
    confirmWorkOrders(payload)
      .then(() => {
        const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");
        dispatch(getScheduleByDay(formattedDate));
        SuccessMessage("Work orders confirmed");
        setConfirmAllWO(false);
        setWorkOrderId(null);
        setLoading(false);
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
          setLoading(false);
        } else {
          ErrorMessage("Something went wrong");
          setLoading(false);
        }
      });
  };

  const confirmAllWorkOrdersPopUp = {
    visibility: confirmAllWO,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setConfirmAllWO(false)}
        heading="Confirm all work orders for this route"
        paragraph={
          <Fragment>
            This will mark all work orders completed by the crew as confirmed.
            <br />
            <br />
            Are you sure you want to proceed?
          </Fragment>
        }
        btnText="Confirm"
        loading={false}
        isArchivePopup
        btnApi={btnConfirmAllWorkOrders}
      />
    ),
    width: 480,
    onCancel: () => setConfirmAllWO(false),
  };

  useEffect(() => {
    if (visitData?.visitWorkOrders && visitData?.visitWorkOrders.length > 0) {
      const workOrderArray = visitData?.visitWorkOrders.filter(
        (wo: any) => wo.work_order_id
      );

      const tasksArray = visitData?.visitWorkOrders.filter(
        (wo: any) => wo.task_id
      );

      setWorkOrderIds(workOrderArray);
      setTaskIds(tasksArray);
    }
  }, [visitData]);

  return (
    <div className="visitDataCard">
      <div className="visitCardHeader">
        <h3>Visit details</h3>

        <div
          className="visitHeaderRight"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "6px",
          }}
        >
          <Tag className={cardClass} style={{ textTransform: "capitalize" }}>
            {
              WORK_ORDER_STATUS[
                visitData?.status as keyof typeof WORK_ORDER_STATUS
              ]
            }
          </Tag>

          {(visitData?.status === "SCHEDULED" ||
            visitData?.status === "CONFIRMATION_PENDING" ||
            visitData?.status === "IN_PROGRESS") && (
            <Dropdown
              menu={{
                items:
                  visitData?.status === "SCHEDULED"
                    ? itemsScheduled
                    : visitData?.status === "CONFIRMATION_PENDING"
                    ? itemsPending
                    : visitData?.status === "IN_PROGRESS"
                    ? itemsInProgress
                    : undefined,
              }}
              trigger={["click"]}
              placement="bottomRight"
              className="actionButton"
            >
              <Button
                ref={dropdownRef}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                onKeyDown={(e) => e.stopPropagation()}
                className="only_icon"
                icon={<MoreOutlined />}
              />
            </Dropdown>
          )}
        </div>
      </div>

      <div className="visitAddress">
        <div className="addressImage">
          <Avatar size={40} src="/images/dummy/address-dummy.svg" />
          <div className="addressInfo">
            <h5>{visitData?.title}</h5>
            <div className="addressLabel">
              <Image
                src="/images/estimate/address-icon.svg"
                preview={false}
                width={12}
              />
              <p>{visitData?.property_address}</p>
            </div>
          </div>
          {visitData?.property?.address_note && (
            <div className="summaryIcon">
              <Tooltip
                title={
                  <>
                    <span>Property note:</span>
                    <p>{visitData?.property?.address_note}</p>
                  </>
                }
                getPopupContainer={(trigger) =>
                  trigger.parentElement || document.body
                }
                arrow={false}
                placement="bottomLeft"
              >
                <Image
                  src="/images/estimate/summary-icon.svg"
                  preview={false}
                />
              </Tooltip>
            </div>
          )}
        </div>
        <div className="visitWrapper">
          <div className="visitTiming">
            <label>Visit time:</label>
            <h4>
              {visitData?.start_time &&
                dayjs(visitData?.start_time).format("h:mm A")}{" "}
              -{" "}
              {visitData?.end_time &&
                dayjs(visitData?.end_time).format("h:mm A")}
            </h4>
          </div>
          <div className="visitTiming">
            <label>Contract:</label>
            <h4>{visitData?.contract_name}</h4>
          </div>
        </div>

        <Card className="preferCard">
          <p>Preferred visit time:</p>
          <div className="preferInfo">
            <div className="preferLeft">
              <Tag>Mo</Tag>
              <Tag>Tu</Tag>
              <Tag>We</Tag>
            </div>
            <div className="preferRight">
              <Tag>10:00 AM - 12:00 PM</Tag>
            </div>
          </div>
        </Card>

        {workOrderIds?.length > 0 && (
          <Collapse
            accordion
            items={[
              {
                key: "1",
                label: (
                  <>
                    <> Work orders </>
                    <Tag
                      style={{
                        height: "20px",
                        width: "20px",
                        backgroundColor: "#D0F2E8",
                        border: "unset",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {workOrderIds?.length}
                    </Tag>
                  </>
                ),
                children: (
                  <div className="popOverCollapseContent">
                    {workOrderIds?.map((workOrder: any) => (
                      <Card key={workOrder?.id}>
                        <div className="contentTitle">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            {workOrder?.status === "COMPLETED" && (
                              <Image
                                src="/images/estimate/selected-icon.svg"
                                preview={false}
                              />
                            )}
                            {workOrder?.status === "CONFIRMATION_PENDING" && (
                              <Image
                                src="/images/estimate/selected-icon.svg"
                                preview={false}
                              />
                            )}
                            {workOrder?.status === "IN_PROGRESS" && (
                              <Image
                                src="/images/schedule/popup/indicator.svg"
                                preview={false}
                              />
                            )}
                            {workOrder?.status === "SCHEDULED" && (
                              <Image
                                src="/images/schedule/popup/indicator.svg"
                                preview={false}
                              />
                            )}
                            <span>{workOrder?.work_order_name}</span>
                          </div>

                          <Dropdown
                            menu={{
                              items: itemsWorkOrder,
                            }}
                            trigger={["click"]}
                            placement="bottomRight"
                            className="actionButton"
                          >
                            <Button
                              onClick={() => {
                                setVisitWorkOrderData(visitData);
                                setWorkOrderId(workOrder?.id);
                              }}
                              ref={dropdownRef}
                              onKeyDown={(e) => e.stopPropagation()}
                              className="only_icon"
                              icon={<MoreOutlined />}
                            />
                          </Dropdown>
                        </div>
                        <div className="contentTime">
                          <div className="timeSpan">
                            <div
                              style={{
                                display: "flex",
                                gap: "4px",
                                alignItems: "center",
                                width: "auto",
                                background: "#E7F9F3",
                                padding: "2px 4px",
                                borderRadius: "10px",
                              }}
                            >
                              <Image
                                src="/images/estimate/clock-icon.svg"
                                preview={false}
                                style={{ height: "14px", width: "14px" }}
                              />
                              <p
                                style={{
                                  whiteSpace: "nowrap",
                                  fontSize: "12px",
                                  color: "#151718",
                                }}
                              >
                                {formatEstimatedHrs(workOrder?.scheduled_hrs)}
                              </p>

                              {workOrder?.status !== "SCHEDULED" && (
                                <Progress
                                  strokeColor="#00A07D"
                                  percent={(() => {
                                    const estimated =
                                      Number(workOrder?.scheduled_hrs) || 0;
                                    const done =
                                      Number(workOrder?.actual_hrs) || 0;
                                    if (estimated <= 0) return 0;
                                    return Math.min(
                                      100,
                                      Math.round((done / estimated) * 100)
                                    );
                                  })()}
                                  size={["75%", 3]}
                                  style={{
                                    marginLeft: "4px",
                                    display: "inline-flex",
                                  }}
                                />
                              )}
                            </div>
                            {workOrder?.work_order?.is_recurring && (
                              <div className="recurring_number">
                                <img
                                  src="/images/schedule/recurring-icon.svg"
                                  alt="icon"
                                />
                                <span>
                                  {
                                    workOrder?.work_order
                                      ?.scheduled_no_of_visits
                                  }
                                  /{workOrder?.work_order?.total_no_of_visits}
                                </span>
                              </div>
                            )}
                          </div>

                          {workOrder?.status === "CONFIRMATION_PENDING" && (
                            <div>
                              <Button
                                className="mint-btn btn-sm"
                                onClick={() => {
                                  setWorkOrderId(workOrder?.work_order_id);
                                  setConfirmAllWO(true);
                                }}
                              >
                                Confirm
                              </Button>
                            </div>
                          )}
                          {workOrder?.status === "COMPLETED" && (
                            <div>
                              <Button className="outlined-btn btn-sm" disabled>
                                Completed
                              </Button>
                            </div>
                          )}
                        </div>
                      </Card>
                    ))}
                  </div>
                ),
              },
            ]}
            expandIcon={({ isActive }) => (
              <SelectArrow style={{ rotate: isActive ? "265px" : "90px" }} />
            )}
          />
        )}
        {taskIds?.length > 0 && (
          <Collapse
            accordion
            items={[
              {
                key: "1",
                label: (
                  <>
                    <> Task </>
                    <Tag
                      style={{
                        height: "20px",
                        width: "20px",
                        backgroundColor: "#D0F2E8",
                        border: "unset",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      {taskIds?.length}
                    </Tag>
                  </>
                ),
                children: (
                  <div className="popOverCollapseContent">
                    {taskIds?.map((task: any) => (
                      <Card key={task?.id}>
                        <div className="contentTitle">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            {task?.status === "COMPLETED" && (
                              <Image
                                src="/images/estimate/selected-icon.svg"
                                preview={false}
                              />
                            )}
                            {task?.status === "CONFIRMATION_PENDING" && (
                              <Image
                                src="/images/estimate/selected-icon.svg"
                                preview={false}
                              />
                            )}
                            {task?.status === "IN_PROGRESS" && (
                              <Image
                                src="/images/schedule/popup/indicator.svg"
                                preview={false}
                              />
                            )}
                            {task?.status === "SCHEDULED" && (
                              <Image
                                src="/images/schedule/popup/indicator.svg"
                                preview={false}
                              />
                            )}
                            <span>{task?.task_name}</span>
                          </div>

                          {/* <Dropdown
                            menu={{
                              items: itemsWorkOrder,
                            }}
                            trigger={["click"]}
                            placement="bottomRight"
                            className="actionButton"
                          >
                            <Button
                              onClick={() => {
                                setVisitWorkOrderData(visitData);
                                setWorkOrderId(task?.task_id);
                              }}
                              onKeyDown={(e) => e.stopPropagation()}
                              className="only_icon"
                              icon={<MoreOutlined />}
                            />
                          </Dropdown> */}
                        </div>
                        <div className="contentTime">
                          <div className="timeSpan">
                            {/* <div
                              style={{
                                display: "flex",
                                gap: "8px",
                                alignItems: "center",
                                width: "auto",
                              }}
                            >
                              <Image
                                src="/images/estimate/clock-icon.svg"
                                preview={false}
                                style={{ height: "14px", width: "14px" }}
                              />
                              <p>
                                {formatEstimatedHrs(task?.estimated_hrs)}
                              </p>
                            </div> */}
                            {/* {task?.status !== "scheduled" && (
                              <Progress
                                strokeColor="#00A07D"
                                percent={50}
                                size={["75%", 3]}
                                style={{
                                  marginLeft: "4px",
                                  display: "inline-flex",
                                }}
                              />
                            )} */}
                          </div>
                          {task?.status === "CONFIRMATION_PENDING" && (
                            <div>
                              <Button
                                className="mint-btn btn-sm"
                                onClick={() => {
                                  setWorkOrderId(task?.task_id);
                                  setConfirmAllWO(true);
                                }}
                              >
                                Confirm
                              </Button>
                            </div>
                          )}
                          {task?.status === "COMPLETED" && (
                            <div>
                              <Button className="outlined-btn btn-sm" disabled>
                                Completed
                              </Button>
                            </div>
                          )}
                        </div>
                      </Card>
                    ))}
                  </div>
                ),
              },
            ]}
            expandIcon={({ isActive }) => (
              <SelectArrow style={{ rotate: isActive ? "265px" : "90px" }} />
            )}
          />
        )}
      </div>
      <PopUp {...rescheduleVisit} />
      <PopUp {...unscheduleRemainingVisitsPopUp} />
      <PopUp {...rescheduleWO} />
      <PopUp {...confirmAllWorkOrdersPopUp} />
      <PopUp {...unscheduleRemainingWOPopUp} />
      <PopUp {...separateVisitPopUp} />
    </div>
  );
}

export default PopOverCard;
